import { Button, DisplayText, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import {
  CHAT_TIMER_INSEC,
  EVENT,
  EVENT_MESSAGE_MAP,
  closeChatWindow,
  killChatWindow
} from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { injectIntl, FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import TimerComponent from './TimerComponent';

function InfoText({
  timer,
  plainText = false,
  message = '',
  threadData,
  sendMessage,
  allConversation,
  isWeb,
  chatStatus,
  closeSession,
  clearChatData,
  readOnly = false,
  minimise = false,
  isOnDemandChatVersion
}) {
  const negativeEvent = [EVENT.REQUESTER_NOT_ACCEPTED, EVENT.SESSION_CLOSED];

  const getMessage = () => {
    switch (message) {
      case EVENT.ASSET_OFFLINE:
      case EVENT.SESSION_CLOSED:
        return isWeb ? (
          <FormattedMessage id={EVENT_MESSAGE_MAP[message] ?? message} />
        ) : (
          <FormattedMessage id="msp.chat.requester.session.ended" />
        );
      default:
        return <FormattedMessage id={EVENT_MESSAGE_MAP[message] ?? message} />;
    }
  };

  switch (true) {
    case timer:
      return (
        <>
          {isWeb ? (
            <div className="fx jctr py15">
              <TextStyle variation="subdued">
                <TimerComponent
                  timerInSec={CHAT_TIMER_INSEC}
                  threadData={threadData}
                  allConversation={allConversation}
                  sendMessage={sendMessage}
                  chatStatus={chatStatus}
                  closeSession={closeSession}
                  minimise={minimise}
                />
              </TextStyle>
            </div>
          ) : (
            <></>
          )}
        </>
      );
    case plainText:
      return (
        <div className="flex-center fcol py15">
          <DisplayText>
            <TextStyle
              variation={
                negativeEvent.includes(message) ? 'negative' : 'subdued'
              }
            >
              {!isEmpty(message) ? <>{getMessage()}</> : message}
            </TextStyle>
          </DisplayText>
          {!readOnly && negativeEvent.includes(message) && (
            <div className="mbt5">
              <Button
                plain
                onClick={() => {
                  if (isWeb) {
                    closeSession({
                      convThread: threadData,
                      closeOnlyWindow: message === EVENT.SESSION_CLOSED
                    });
                    isOnDemandChatVersion
                      ? killChatWindow()
                      : closeChatWindow();
                  } else {
                    clearChatData();
                    isOnDemandChatVersion
                      ? killChatWindow()
                      : closeChatWindow();
                  }
                }}
              >
                <DisplayText>
                  <FormattedMessage id="app.close.btn" />
                </DisplayText>
              </Button>
            </div>
          )}
        </div>
      );

    default:
      return <div />;
  }
}

export default injectIntl(InfoText);
